<template>
    <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :title="'修改'+labelText"
        :visible.sync="dialogVisible"
        width="650px"
        top="50px"
        :before-close="handleClose">
        <div class="content-wrap pr20 mt20">
            <el-form ref="form" :model="formItem" :rules="rules" label-width="100px">
                <el-form-item :label="labelText+'：'" prop="text">
                    <el-input v-model.trim="formItem.text" clearable :placeholder="'请输入'+labelText" @keyup.native="changeText" :maxlength="wordLimit>0?wordLimit:''" :show-word-limit="wordLimit>0" class="word-limit-input" style="width:450px"></el-input>
                    <p class="text-color-error"></p>
                </el-form-item>
                <el-form-item v-if="type=='sub_title'">
                    <p class="text-color-error font12px">副标题中不能出现单个”{”、”}”，如果需要填写动态词组请组合使用“{}”，填写的词组名称请保持和媒体名称一致，并且不可超过两个动态词组</p>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer tac">
            <el-button type="default" @click="handleClose" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="submitLoading" class="action-btn ml20">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import API from '@/api/marketManage/vivoBatch';
    export default {
        name: "IdeaSettingModal.vue",
        props:{
            type:String,
            data:Array,
        },
        data(){
            let _this = this;
            const validateText = (rule, value, callback) => {
                if(/[^\u0020-\u007E\u00A0-\u00BE\u2E80-\uA4CF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF\u0080-\u009F\u2000-\u201f\u2026\u2022\u20ac\r\n]/g.test(value)){
                    callback(new Error(_this.labelText+'不能输入表情'));
                }
                if(_this.type=='app_name'){
                    if (value === '') {
                        callback();
                    } else {
                        callback();
                    }
                }else if(_this.type=='sub_title'){
                    if (value === '') {
                        callback();
                    } else if(value.includes('$')){
                        callback(new Error(_this.labelText+'不能包含$'));
                    }else {
                        callback();
                    }
                }else if(_this.type=='view_monitor_url'||_this.type=='click_monitor_url'){
                    if(!value){
                        callback();
                    }else if(!value.startsWith('https://')){
                        callback(new Error('需要以https://开头，并且名称中只能包含英文、数字及+&@#/%?=~_|{}!:,.字符，并且?!:,.字符不能在末尾'));
                    }else if(/[?!:,.]$/.test(value)){
                        callback(new Error('需要以https://开头，并且名称中只能包含英文、数字及+&@#/%?=~_|{}!:,.字符，并且?!:,.字符不能在末尾'));
                    }else if(/[\u4E00-\u9FA5]/.test(value)){
                        callback(new Error('需要以https://开头，并且名称中只能包含英文、数字及+&@#/%?=~_|{}!:,.字符，并且?!:,.字符不能在末尾'));
                    }else if(!/^https:\/\/[\d\w+&@#\/%?=~_|{}!:,.\-]+$/.test(value)){
                        callback(new Error('需要以https://开头，并且名称中只能包含英文、数字及+&@#/%?=~_|{}!:,.字符，并且?!:,.字符不能在末尾'));
                    }else{
                        callback();
                    }
                }

            };
            return {
                dialogVisible:false,
                formItem:{
                    text:'',
                },
                submitLoading:false,
                rules:{
                    text: [
                        { validator: validateText, trigger: 'blur' }
                    ],
                },
            };
        },
        computed:{
            labelText(){
                let titleMap = {
                    app_name:'应用名称',
                    sub_title:'应用副标题',
                    view_monitor_url:'曝光监测链接',
                    click_monitor_url:'点击监测链接',
                };
                return titleMap[this.type]||'';
            },
            wordLimit(){
                if(this.type=='app_name') return 10;
                if(this.type=='sub_title') return 15;
                return 0;
            }
        },
        methods:{
            handleClose(){
                this.dialogVisible = false;
                this.resetForm();
            },
            resetForm(){
                console.log('reset form',this.$refs.form);
                this.submitLoading = false;
                this.formItem.text = '';
                let $form = this.$refs.form;
                if($form){
                    $form.resetFields();
                }
            },
            showModal(){
                this.formItem.text = '';
                this.dialogVisible = true;
                if(this.data.length==1){
                    this.$nextTick(()=>{
                        let rowData = this.data[0]||{};
                        this.formItem.text = rowData[this.type];
                    })
                }
            },
            handleSubmit(){
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        console.log('handleSubmit');
                        this.submitLoading = true;
                        let data = this.data||[];
                        if(data.length<=0) return this.$message.error('请先选择需要修改的创意');
                        if(this.type=='app_name'||this.type=='sub_title'){
                            API.modifyIdeaInfo({
                                type:this.type,
                                name:this.formItem.text,
                                detail_idea_ids:data.map(item=>item.detail_idea_id).join(','),
                            }).then(res=>{
                                console.log('modifyIdeaInfo',res);
                                this.$emit('update');
                                this.submitLoading = false;
                                this.handleClose();
                            },err=>{
                                this.submitLoading = false;
                                this.$message.error(err.info||'操作失败');
                            })
                        }else if(this.type=='view_monitor_url'||this.type=='click_monitor_url'){
                            API.modifyAdInfo({
                                type:this.type,
                                data:this.formItem.text,
                                detail_ids:data.map(item=>item.detail_id).join(','),
                            }).then(res=>{
                                console.log('modifyIdeaInfo',res);
                                this.$emit('update');
                                this.submitLoading = false;
                                this.handleClose();
                            },err=>{
                                this.submitLoading = false;
                                this.$message.error(err.info||'操作失败');
                            })
                        }
                    } else {
                        return false;
                    }
                });
            },
            changeText(){
                this.formItem.text = this.formItem.text.replace(/\s/g,'');
            },
        }
    }
</script>

<style scoped>

</style>
